import { useContext } from "react"
import { IconArrowCornerUpLeftOutline18 as CornerUpLeft } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/browser"

import {
	settingsNavGroupClass,
	SettingsNavRow,
} from "../settings-pages/settings-nav-row"
import { SettingsCardInsetContext } from "../settings-switches/settings-container"

export const ForwardedEmailHandlingCard = () => {
	const inset = useContext(SettingsCardInsetContext)
	return (
		<div className={cn(settingsNavGroupClass, !inset && "sm:mx-0")}>
			<SettingsNavRow
				icon={CornerUpLeft}
				title="Forwarded email handling"
				description="Choose whether forwarded emails are attributed to the original sender or the forwarder."
				link="/settings/emails/forwarding"
			/>
		</div>
	)
}
